import indexPage from './indexPage';

function hideLoading($button) {
	indexPage.allowSubmit = true;
	$button.removeClass('disabled loading').attr('aria-busy', false);
}

export default hideLoading;
